import React from "react";
import { string, arrayOf, bool } from "prop-types";
import ShoulderTags from "../ShoulderTags";

import "./section-heading.m.css";

const SectionHeading = ({ 
  highlightText, 
  normalText,
  tags, 
  isMobile = false, 
  ...props 
}) => {
  return (
    <div styleName="section-heading" {...props}>
      <div styleName="top-row">
        <h2 styleName="title">
          <ShoulderTags tags={tags} />
          <span styleName="highlight">{highlightText} </span>
          <span styleName="normal">{normalText}</span>
        </h2>
      </div>
    </div>
  );
};

SectionHeading.propTypes = {
  highlightText: string.isRequired,
  normalText: string.isRequired,
  subtitle: string.isRequired,
  tags: arrayOf(string).isRequired,
  isMobile: bool
};

export default SectionHeading;